import { XYpos } from '../types/XYpos';

export default function find3ptAngle(a: XYpos, b: XYpos, c: XYpos) {
  const AB = Math.sqrt((b.x - a.x) ** 2 + (b.y - a.y) ** 2);
  const BC = Math.sqrt((b.x - c.x) ** 2 + (b.y - c.y) ** 2);
  const AC = Math.sqrt((c.x - a.x) ** 2 + (c.y - a.y) ** 2);
  return Math.acos((BC * BC + AB * AB - AC * AC) / (2 * BC * AB));
}
